import logo from "../assets/icons/loading-icon.svg";
import "../styles/components/loader.css";

const Loader = () => (
    <div className="loader-wrapper">
        <div className="loader">
            <img src={logo} alt="logo" className="loader-logo" />
        </div>
    </div>
);

export default Loader;
